import { SURVIVOR_RIG_MANIFEST } from "../generated/survivorRigManifest.generated";

export const SURVIVOR_RIG_VERSION = SURVIVOR_RIG_MANIFEST.version;
export const SURVIVOR_RIG_PROFILES = SURVIVOR_RIG_MANIFEST.profiles;
export const SURVIVOR_RIG_CELLS = SURVIVOR_RIG_MANIFEST.cells;

export type SurvivorRigCell = typeof SURVIVOR_RIG_CELLS[number];

export interface SurvivorRigBoneDefinition {
  id: string;
  parent: string | null;
  frame: SurvivorRigCell;
  pivot: readonly [number, number];
  drawOrder: number;
}

/**
 * Generated, verifier-backed hierarchy and normalized pivots for the assembled
 * 256 x 512 puppet canvas. Clothing overlaps hide the joints beneath collars,
 * cuffs, hems, and boots.
 */
export const SURVIVOR_RIG_BONES: readonly SurvivorRigBoneDefinition[] = SURVIVOR_RIG_MANIFEST.bones;
export const SURVIVOR_RIG_PROPS = SURVIVOR_RIG_MANIFEST.props;
